import { cn } from '@/lib/utils';

type HeaderBrandLogoProps = {
  src: string;
  alt: string;
  variant?: 'nav' | 'sheet';
  className?: string;
};

/**
 * Fixed logo slot so client uploads (any size/aspect) scale consistently in the header.
 * object-contain keeps proportions; the slot forces a readable brand size.
 */
export function HeaderBrandLogo({
  src,
  alt,
  variant = 'nav',
  className,
}: HeaderBrandLogoProps) {
  const isSheet = variant === 'sheet';

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-start',
        isSheet
          ? 'h-10 w-[150px]'
          : 'h-12 w-[170px] sm:w-[200px] lg:h-[52px] lg:w-[240px]',
        className
      )}
    >
      <img
        src={src}
        alt={alt}
        className="h-full w-full object-contain object-left"
        decoding="async"
      />
    </div>
  );
}
